<template>
  <transition name="myDialog">
    <div :visible="dialogVisible" class="mask-layer" :style="{ 'z-index': zIndex }" @click="close">
      <div :class="{modal: true,hasNoMaxWidth: hasNoMaxWidth}" :style="modelBgi">
        <img v-show="showSuccess" class="success-icon" src="../../assets/road/icon-success.png" />
        <img style="border: 1px solid transparent;" v-if="showClose" :class="['close-img',{'m-close': isMobile}]" :src="require(`@/assets/${closeImage}`)" @click="close" />
        <div :class="['modal-content',{m:isMobile}]">
          <slot></slot>
          <p class="modal-title" :style="`color:${sendColor}`">{{ errorMsg.title }}</p>
          <p class="modal-text">{{ errorMsg.content }}</p>
          <slot name="footer"></slot>
        </div>
        <div v-if="showButton" :class="['close-btn',{'m-close': isMobile}]" @click="close" :style="`background-image: url(${closeBtnImg})`">
          ĐÓNG
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { isMobile } from "../../utils/tools";

export default {
  name: "SysDialog",
  props: {
    sendColor: {
      type: String,
      default: ''
    },
    hasNoMaxWidth: {
      type: Boolean,
      default: false
    },
    bgi: {
      type: String
    },
    showSuccess: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showButton: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 2100
    },
    errorMsg: {
      type: Object,
      default: () => {
        return {
          title: "",
          content: ""
        };
      }
    },
    dialogVisible: {
      type: Boolean
    },
    closeImage: {
      type: String,
      default: "icon-close.png"
    },
    closeBtnImg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      modelBgi: {
        backgroundImage: `url(${this.bgi})`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat"
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="less" scoped>
@plugin "../../utils/plugin";
@font-face {
  font-family: "UTMMabella";
  src: url("../../assets/font/UTM-Mabella.ttf");
}

.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal {
    position: relative;
    transform: scale(1);
    //padding: px(100) 70px;
    max-width: 70%;

    &.hasNoMaxWidth {
      max-width: unset;
    }

    img.success-icon {
      width: 19.0397%;
      position: absolute;
      top: 25.7069%;
      left: 39.735%;
    }

    .modal-content {
      width: px(417);
      height: px(165);
      color: #5a5a5a;
      font-size: px(24);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      background-color: white;
      border-radius: px(30);

      .modal-title {
        font-weight: 800;
        font-size: px(24);
        font-family: UTMErieBlack;
        margin: 0;
        color: #4098d8;
      }

      .modal-text {
        font-size: px(18);
        font-family: UTMAvo;
        font-weight: 500;
        margin: px(23) 0 0;
        //width: 90%;
      }

      //@media only screen and (min-width: 320px) and (max-width: 576px) and (orientation: portrait) {
      //  .modal-title {
      //    font-size: 22px;
      //  }
      //
      //  .modal-text {
      //    font-size: 16px;
      //    margin-top: 10px;
      //  }
      //}
    }

    .m {
      width: 417px;
      height: 165px;
      border-radius: 30px;
      .modal-title {
        font-size: 24px;
      }

      .modal-text {
        font-size: 18px;
      }
    }

    .close-img {
      top: 0px;
      right: 0px;
      position: absolute;
      cursor: pointer;
    }

    .close-btn {
      height: 100px;
      width: 250px;
      background-size: 100% 100%;
      cursor: pointer;
      position: absolute;
      left: calc(50% - 125px);
      bottom: -50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-family: UTMMabella;
      font-size: 32px;
    }
    .m-close {
      width: 60px;
      height: 60px;
    }

    //@media only screen and (max-width: 767px) {
    //  .close-img {
    //    top: -15px;
    //    right: -15px;
    //    height: 40px;
    //    width: 40px;
    //  }
    //}
    //
    //@media only screen and (max-width: 600px) {
    //  .close-img {
    //    top: -15px;
    //    right: -15px;
    //    height: 40px;
    //    width: 40px;
    //  }
    //}
    //
    //@media only screen and (max-width: 350px) {
    //  .close-img {
    //    top: -12px;
    //    right: -12px;
    //    height: 35px;
    //    width: 35px;
    //  }
    //}
  }

  @media only screen and (max-width: 350px) {
    .modal {
      padding: 20px;
    }
  }
  @media only screen and (max-width: 600px) {
    .modal {
      padding: 30px;
    }
  }
}

.myDialog-enter-active,
.myDialog-leave-active {
  transition: all 0.3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysDialog.vue